<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>订单管理</el-breadcrumb-item> -->
      <el-breadcrumb-item>保险订单新增</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
      <!-- 险种方案 -->
    <el-card class="box-card" style="margin-top:20px">
      <el-row :gutter="20">
            <el-col :span="9">
              <el-form
                  :inline="true"
                  :model="isTableSearchForm"
                  ref="isSearchForRef"
                  label-width="100px"
                  autocomplete="on"
                >
                <el-form-item label="险种方案名称" size="small">
                  <el-input v-model="isTableSearchForm.productName" clearable placeholder="请输入险种方案名称" type="text" name="productName"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="1">
              <el-button type="success" @click="isSearchSubmit()" size="small">搜索</el-button>
              <!-- <el-button @click="searchRest()">重置</el-button> -->
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            ref="multipleTable"
            :data="isTableData"
            border
            height="260"
            :header-cell-style="{background:'#F8F8F9'}"
            >
            <!-- <el-table-column
              type="selection"
              width="55">
            </el-table-column> -->
            <el-table-column label="选择" align="center" width="55">
              <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="radio"
              @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="险种方案"
              width="120">
            </el-table-column>
            <el-table-column
              label="产品名称"
              width="100">
              <template slot-scope="scope">{{ scope.row.product.name }}</template>
            </el-table-column>
            <el-table-column
              label="保司名称"
              width="100">
              <template slot-scope="scope">{{ scope.row.corp.name }}</template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="渠道名称"
              width="120">
              <template slot-scope="scope">{{ scope.row.channel.name }}</template>
            </el-table-column>
            <el-table-column
              prop="real_price"
              label="保费（元）"
              width="100">
            </el-table-column>
            <el-table-column
              prop="price"
              label="净费（元）"
              width="100">
            </el-table-column>
            <el-table-column
              prop="desc"
              label="承保要求"
              width="100"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              label="图片"
              width="60"
              >
              <template slot-scope="scope">
                <viewer>
                  <img :src="scope.row.image " min-width="20" height="20"/>
                </viewer>
              </template>
            </el-table-column>
            <el-table-column
              prop="cpys"
              label="产品优势"
              width="120"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="方案保障"
              width="350"
              show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <el-form
              style="margin-top:20px"
              :inline="true"
              :model="productMdForm"
              :rules="productMdRules"
              ref="productForRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-row :gutter="24">
                <!-- <el-col :span="8">
                    <el-form-item label="外放净费" size="small" prop="salePrice" label-width="80px">
                      <el-input placeholder="请输入外放净费" v-model="productMdForm.salePrice" @change="changeSalePrice" type="text"></el-input>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :span="8">
                    <el-form-item label="收款类型" size="small">
                      <el-select
                        v-model="productMdForm.type"
                        placeholder="请选择"
                      >
                        <el-option label="银行卡" :value="1"></el-option>
                        <el-option label="微信" :value="2"></el-option>
                        <el-option label="支付宝" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :span="8">
                    <el-form-item label="生效日期" size="small" prop="effective_date" label-width="80px">
                        <el-date-picker type="date" v-model="productMdForm.effective_date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="保费" size="small" label-width="80px">
                      <el-input v-model="productMdForm.sell_price" disabled type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="支付凭证" size="small" label-width="80px" >
                      <el-input v-model="productMdForm.pay_sn" type="text">
                      </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
               
                <el-col :span="7" v-if="isCorpId">
                    <el-form-item label="投保单号" size="small" label-width="80px">
                      <el-input v-model="productMdForm.policy_no" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="7" v-if="isCorpId">
                    <el-form-item label="保险单号" size="small" label-width="80px">
                      <el-input v-model="productMdForm.proposal_form" type="text"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <!-- <el-col :span="8">
                    <el-form-item label="净费" size="small" label-width="80px">
                      <el-input v-model="productMdForm.price" disabled type="text"></el-input>
                    </el-form-item>
                </el-col>
             
                <el-col :span="8">
                    <el-form-item label="毛利润" size="small" label-width="80px">
                      <el-input v-model="productMdForm.profit"  type="text"></el-input>
                    </el-form-item>
                </el-col> -->
            </el-row>
            <el-row :gutter="24">
                <!-- <el-col :span="8">
                    <el-form-item label="绩效" size="small" label-width="80px">
                      <el-input v-model="productMdForm.commission" type="text"></el-input>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :span="8">
                  <el-form-item label="业务渠道" size="small" label-width="80px" prop="member_name" >
                    <el-select v-model="productMdForm.member_name" 
                      placeholder="请选择业务渠道" clearable 
                      filterable
                      @blur="selectBlur"
                      @clear="selectClear"
                      @change="selectChange">
                  <el-option v-for="item in busTableData" :key="item.id" :label="item.contact_name"
                       :value="item.id"></el-option>
                  </el-select>
                  </el-form-item>
                </el-col> -->
                <!-- <el-col :span="8">
                  <el-form-item label="业务渠道" size="mini" label-width="70px">
                    <el-input readonly @focus="busChannel()" v-model="productMdForm.member_name" placeholder="请选择" type="text"></el-input>
                  </el-form-item>
                </el-col> -->
            </el-row>
          </el-form>
          <!-- <el-row :gutter="24">
            <el-col :span="10" :offset="20">
              <el-button type="success" size="small" @click="productMdFormSubmit()">确认</el-button>
            </el-col>
          </el-row> -->
    </el-card>
    <el-card class="box-card" style="margin-top:20px">
        <!-- 新增-->
        <el-form
            :inline="true"
            :model="addForm"
            ref="addForRef"
            autocomplete="on"
            size="mini"
          >
          <div class="upload_group">
            <div class="upload_list">
              <el-upload
                  :on-change="handleChangeOne"
                  class="upload-demo"
                  drag
                  :limit="1"
                  :auto-upload="false"
                  :file-list="fileListOne"
                  :show-file-list="false"
                  action="/source/upload" 
	                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG"
                  >
                  <!-- <i class="el-icon-upload"></i> -->
                  <div class="el-upload__text">点击/拖拽行驶证</div>
                </el-upload>
                <viewer>
                  <img :src="carUrl" style="width:120px; height:50px" />
                </viewer>
            </div>
            <div class="upload_list">
              <el-upload
                  :on-change="handleChangeThree"
                  class="upload-demo"
                  drag
                  :limit="1"
                  :auto-upload="false"
                  :file-list="fileListThree"
                  :show-file-list="false"
                  action=""
                  >
                  <!-- <i class="el-icon-upload"></i> -->
                  <div class="el-upload__text">点击/拖拽营业执照</div>
                </el-upload>
                <viewer>
                  <img :src="shopUrl" style="width:120px; height:50px" />
                </viewer>
            </div>
            <div class="upload_list">
              <div class="el_upload_border" @click="handleChangeShop">点击上传商业险</div>
              <viewer>
                 <img :src="policyUrl" style="width:120px; height:50px" />
              </viewer>  
            </div>
            <div class="upload_list" >
                <div class="el_upload_border"  @click="handleChangeInsure">点击上传投保声明</div>
                <viewer>
                    <img :src="insureUrl" style="width:120px; height:50px" />
                </viewer>
            </div>

          </div>
          <!-- <div>
            <el-divider content-position="left">基础信息，必填</el-divider>
          </div>
          <el-row :gutter="24">
              <el-col :span="8">
                  <el-form-item label="编号" label-width="70px" size="mini">
                        <el-input readonly v-model="baseForm.sn" type="text">
                        </el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工号" size="mini" label-width="70px">
                  <el-input disabled v-model="baseForm.operator_id" type="text" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="维护人员" size="mini" label-width="70px">
                  <el-input disabled v-model="baseForm.operator_id" type="text" clearable></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="所属团队" size="mini" label-width="70px">
                  <el-input disabled v-model="baseForm.team_name" type="text" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="订单时间" size="mini" label-width="70px">
                    <el-date-picker type="date" placeholder="选择日期" v-model="baseForm.chat_date" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="8">
                <el-form-item label="出单人" size="small" prop="employ_id">
                  <el-select
                    v-model="baseForm.employ_id"
                    placeholder="请选择出单人"
                    @change="changeEmployValue($event)"
                  >
                    <el-option v-for="item in employData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="8">
                <el-form-item label="状态" size="mini" label-width="70px">
                  <el-select
                    v-model="baseForm.status"
                    placeholder="请选择状态"
                    clearable
                  >
                    <el-option label="待审核" :value="0"></el-option>
                    <el-option label="已审核" :value="1"></el-option>
                    <el-option label="已出单" :value="2"></el-option>
                    <el-option label="已完成" :value="3"></el-option>
                    <el-option label="取保" :value="4"></el-option>
                    <el-option label="退单" :value="5"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
          </el-row> -->

          <div class="zhu_box">
              <div class="customer_box">
                <el-divider content-position="left">{{ titleCar}}     
                </el-divider>
              </div>
              <!-- 主车信息 -->
              <div class="container">
                  <el-row :gutter="24">  
                      <el-col :span="8">
                        <el-form-item label="所有人" size="mini" label-width="70px">
                              <el-input v-model="addForm.allPerson" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="号牌号码" size="mini" label-width="70px">
                          <el-input v-model="addForm.plate_number" type="text">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="整备质量" size="mini" label-width="70px">
                          <el-input v-model="addForm.curb_weight" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">  
                      <el-col :span="8">
                        <el-form-item label="使用性质" size="mini" label-width="70px">
                          <el-input v-model="addForm.use_character" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="发证单位" size="mini" label-width="70px">
                            <el-input v-model="addForm.unit" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="车辆类型" size="mini" label-width="70px">
                            <el-input v-model="addForm.vehicle_type" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" >
                        <el-form-item label="品牌型号" size="mini" label-width="70px">
                            <el-input v-model="addForm.model" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="注册日期" size="mini" label-width="70px">
                          <el-input v-model="addForm.register_date" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" >
                        <el-form-item label="发证日期" size="mini" label-width="70px">
                          <el-input v-model="addForm.issue_date" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">  
                      <el-col :span="8">
                        <el-form-item label="档案编号" size="mini" label-width="70px">
                            <el-input v-model="addForm.file_no" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="外廓尺寸" size="mini" label-width="70px">
                            <el-input v-model="addForm.out_to_out" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="总质量" size="mini" label-width="70px">
                          <el-input v-model="addForm.total_mass" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="检验记录" size="mini" label-width="70px">
                            <el-input v-model="addForm.record" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="燃油类型" size="mini" label-width="70px">
                          <el-input v-model="addForm.fuel_type" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="证芯编号" size="mini" label-width="70px">
                            <el-input v-model="addForm.core_no" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                    
                  </el-row>
                  <el-row :gutter="24">  
                      <el-col :span="9">
                        <el-form-item label="核定载人数" size="mini" label-width="100px">
                          <el-input v-model="addForm.seating_capacity" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="准牵引总质量" size="mini" label-width="100px">
                          <el-input v-model="addForm.traction_mass" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <!-- <el-col :span="4">
                        <el-form-item label="核定载质量" size="small" label-width="70px">
                          <el-input v-model="addForm.approved_load" type="text"></el-input>
                        </el-form-item>
                      </el-col> -->
                  </el-row>
                  <el-row :gutter="24">  
                      <el-col :span="9">
                        <el-form-item label="车辆识别代号" size="mini" label-width="100px">
                              <el-input v-model="addForm.vin" type="text">
                                <!-- <template #append>
                                  <el-button icon="el-icon-search" />
                                </template> -->
                              </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="发动机号码" size="mini" label-width="100px">
                            <el-input v-model="addForm.engine_number" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">  
                      <el-col :span="9">
                        <el-form-item label="备注" size="mini" label-width="100px">
                          <el-input v-model="addForm.remark" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="住址" size="mini" label-width="100px">
                            <el-input v-model="addForm.address" type="text"></el-input>
                        </el-form-item>
                      </el-col>
                  </el-row>
              </div>
              <!-- 营业执照 -->
              <div class="customer_box">
                <el-divider content-position="left">营业执照
                </el-divider>
                <!-- 营业执照 -->
                <div class="container">
                    <el-row :gutter="24">    
                          <el-col :span="8">
                              <el-form-item label="单位名称" size="mini" label-width="70px">
                                <el-tooltip :content="businessForm.name" placement="bottom" effect="dark">
                                  <el-input v-model="businessForm.name" type="text" clearable></el-input>
                                </el-tooltip>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="类型" size="mini" label-width="70px">
                              <el-tooltip :content="businessForm.type" placement="bottom" effect="dark">
                                <el-input v-model="businessForm.type" type="text" clearable></el-input>
                              </el-tooltip>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                          <el-form-item label="经营范围" size="mini" label-width="70px">
                            <el-tooltip :content="businessForm.business_scope" placement="bottom" effect="dark">
                              <el-input v-model="businessForm.business_scope" type="text" clearable></el-input>
                            </el-tooltip>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="税号" size="mini" label-width="70px">
                              <el-input v-model="businessForm.taxes_no" type="text" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="成立日期" size="mini" label-width="70px">
                            <el-input v-model="businessForm.incorporation_date" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-form-item label="开户行">
                              <el-input v-model="businessForm.sn" type="text" clearable name=""></el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                          <el-form-item label="法人" size="mini" label-width="70px">
                            <el-input v-model="businessForm.corporation" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-form-item label="银行账号">
                              <el-input v-model="businessForm.sn" type="text" clearable name=""></el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                          <el-form-item label="注册资本" size="mini" label-width="70px">
                            <el-input v-model="businessForm.registered_capital" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <!-- <el-col :span="6">
                          <el-form-item label="电话号码">
                            <el-input v-model="businessForm.vin" type="text" clearable name=""></el-input>
                          </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                          <el-form-item label="证件编号" size="mini" label-width="70px">
                            <el-input v-model="businessForm.certificate_no" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="组成形式" size="mini" label-width="70px">
                            <el-input v-model="businessForm.composition" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="有效期" size="mini" label-width="70px">
                            <el-input v-model="businessForm.lifespan" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="核准日期" size="mini" label-width="70px">
                            <el-input v-model="businessForm.issue_date" type="text" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="地址" size="mini" label-width="70px">
                            <el-tooltip :content="businessForm.address" placement="bottom" effect="dark">
                              <el-input v-model="businessForm.address" type="text" clearable></el-input>
                            </el-tooltip>
                          </el-form-item>
                        </el-col>
                          <el-col :span="9">
                            <el-form-item label="社会信用代码" size="mini" label-width="100px">
                              <el-tooltip :content="businessForm.credit_code" placement="bottom" effect="dark">
                                <el-input v-model="businessForm.credit_code" type="text" clearable></el-input>
                              </el-tooltip>
                            </el-form-item>
                          </el-col>
                    </el-row>
                </div> 
              </div>
        </div>

        </el-form>
        <el-row :gutter="20" style="margin-top:20px">
          <el-col :span="4">
            <!-- <el-button size="small">重置</el-button> -->
            <el-button type="primary" size="small" @click="submitAllForm()">保存订单</el-button>
          </el-col>
        </el-row>
      </el-card>
  
    <!-- 支付凭证 -->
    <el-dialog
        :visible.sync="dialogUpload"
        width="650px"
        center>
      <el-form :model="form" :rules="rules" ref="rules" label-width="100px">
        <el-row :gutter="24">
            <el-form-item label="图片上传" v-if="this.dialogImageUrl == ''">
                <div class="pay_upload" v-if="this.dialogImageUrl == ''">
                  <el-upload
                      :on-change="UploadImage"
                      drag
                      :limit="1"
                      :auto-upload="false"
                      :file-list="fileUploadList"
                      :show-file-list="false"
                      action=""
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <img class="pay_img" v-else style="width: 140px;height: 80px" :src="dialogImageUrl" alt="" />
            </el-form-item>
            <img v-else style="width: 100%;height: 100%" :src="dialogImageUrl" alt="" />
        </el-row>
                    <!-- <img class="pay_img" @click="handlePictureCardPreview()" v-else style="width: 140px;height: 80px" :src="dialogImageUrl" alt="" /> -->
                    <!-- <el-dialog title="银行电子回单" append-to-body :visible.sync="neiDialog" width="650px" style="line-height: 0;"> -->
                      <!-- <el-row :gutter="24">
                          <el-col :span="12">
                            <el-form-item label="标题" size="mini" label-width="130px">
                              <el-input v-model="bankForm.title"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电子回单号码" size="mini" label-width="130px">
                              <el-input v-model="bankForm.receipt_sn"></el-input>
                            </el-form-item>
                          </el-col>
                      </el-row> -->
        <el-row :gutter="24">
                      <el-col :span="12">
                <el-form-item label="是否对公" size="small">
                  <el-select
                    v-model="bankForm.is_company"
                    placeholder="请选择"
                    @change="IsCompanyChange"
                  >
                    <el-option label="对公" :value="1"></el-option>
                    <el-option label="净费" :value="0"></el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="佣金" size="small">
                <el-input v-model="bankForm.commission" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="户名（收款人）" size="mini" label-width="130px">
                <el-input v-model="bankForm.account"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="开户银行（收款人）" size="mini" label-width="140px">
                <el-input v-model="bankForm.account_bank_name"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="账号（收款人）" size="mini" label-width="130px">
                <el-input v-model="bankForm.account_number"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="交易流水号" size="mini" label-width="130px">
                <el-input v-model="bankForm.bank_receipt_sn"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
                        <!-- <el-row :gutter="24"> -->
                          <!-- <el-col :span="12">
                            <el-form-item label="摘要" size="mini" label-width="130px">
                              <el-input v-model="bankForm.bank_desc"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="用途" size="mini" label-width="130px">
                              <el-input v-model="bankForm.bank_use"></el-input>
                            </el-form-item>
                          </el-col> -->
                        <!-- </el-row> -->
                        <!-- <el-row :gutter="24">
                          <el-col :span="12">
                            <el-form-item label="金额" size="mini" label-width="130px">
                              <el-input v-model="bankForm.small_amount"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="金额（大写）" size="mini" label-width="130px">
                              <el-input v-model="bankForm.big_amount"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row> -->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="户名" size="mini" label-width="130px">
                  <el-input v-model="bankForm.payee_account"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号（付款人）" size="mini" label-width="130px">
                  <el-input v-model="bankForm.payee_account_number"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="开户银行（付款人）" size="mini" label-width="140px">
                  <el-input v-model="bankForm.payee_bank_name"></el-input>
                </el-form-item>
              </el-col>      -->
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="12">
                <el-form-item label="时间戳" size="mini" label-width="130px">
                  <el-input v-model="bankForm.bank_date"></el-input>
                </el-form-item>
              </el-col> -->

                        <el-col :span="12">
              <el-form-item label="凭证金额" size="small">
                <el-input v-model="bankForm.pay_money" autocomplete="off"></el-input>
              </el-form-item>
            </el-col> 
            <el-col :span="12">
              <el-form-item label="交易日期" size="small">
                <el-date-picker type="date" placeholder="选择日期" v-model="bankForm.pay_date" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
                        <el-col :span="12">
                          <el-form-item label="备注" size="small">
                            <el-input v-model="bankForm.remark" placeholder="请输入备注"  type="textarea" autosize autocomplete="off"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    <!-- </el-dialog> -->
                    <!-- <el-dialog v-model="neiDialog">
                        <img style="width: 100%; height: 100%" :src="dialogImageUrl" alt="" />
                    </el-dialog> -->
            <!-- <el-col :span="8">
                <el-form-item label="是否对公" size="small">
                  <el-select
                    v-model="payInfoform.is_company"
                    placeholder="请选择"
                  >
                    <el-option label="对公" :value="1"></el-option>
                    <el-option label="净费" :value="0"></el-option>
                  </el-select>
                </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="付款人" size="small">
                <el-input v-model="payInfoform.payee_account" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="付款账号" size="small">
                <el-input v-model="payInfoform.payee_account_number" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收款人" size="small">
                <el-input v-model="payInfoform.account" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="收款人账号" size="small">
                <el-input v-model="payInfoform.account_number" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交易日期" size="small">
                <el-date-picker type="date" placeholder="选择日期" v-model="payInfoform.pay_date" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="凭证流水号" size="small">
                <el-input v-model="payInfoform.pay_sn" disabled autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="凭证金额" size="small">
                <el-input v-model="payInfoform.pay_money" autocomplete="off"></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="佣金" size="small">
                <el-input v-model="payInfoform.commission" autocomplete="off"></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="备注" size="small">
                <el-input v-model="payInfoform.remark" placeholder="请输入备注"  type="textarea" autosize autocomplete="off"></el-input>
              </el-form-item>
            </el-col> -->
        <!-- </el-row> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPayInfoSubmit()">取 消</el-button>
        <el-button type="primary" @click="payInfoSubmit()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="上传商业险保单" :visible.sync="policyDialog" width="500px">
      <el-form
              :inline="false"
              :model="policyform"
              :rules="policyrules"
              ref="policyform"
              label-width="90px"
              autocomplete="on"
            >
            <el-form-item label="上传文件" size="small">
              <div class="pay_upload">
                <el-upload
                  class="upload-demo"
                  :on-change="policyUpload"
                  :limit="1"
                  :auto-upload="false"
                  :show-file-list="false"
                  :file-list="filePolicyList"
                  accept=".pdf,.jpg,.jpeg,.png,.gif,.JPG,.JPEG"
                  action=""
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传pdf文件</div> -->
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="开始时间" size="mini" label-width="70px">
                <el-date-picker type="date" placeholder="选择日期" v-model="policyform.start_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="mini" label-width="70px">
                <el-date-picker type="date" placeholder="选择日期" v-model="policyform.end_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="reset_dialogPolicyForm('policyform')">取 消</el-button>
          <el-button type="primary" @click="policySubmitForm('policyform')">确 定</el-button>
      </div>

    </el-dialog>
    <el-dialog title="上传投保声明（盖章资料）" :visible.sync="insureDialog" width="500px">
      <el-form
              :inline="false"
              :model="insureform"
              :rules="insurerules"
              ref="insureform"
              label-width="90px"
              autocomplete="on"
            >
            <el-form-item label="上传文件" size="small">
              <div class="pay_upload">
                <el-upload
                  class="upload-demo"
                  :on-change="insureUpload"
                  :limit="1"
                  :auto-upload="false"
                  :show-file-list="false"
                  :file-list="fileinsureList"
                  accept=".pdf,.jpg,.jpeg,.png,.gif,.JPG,.JPEG"
                  action=""
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传pdf文件</div> -->
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="开始时间" size="mini" label-width="70px">
                <el-date-picker type="date" placeholder="选择日期" v-model="insureform.start_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="mini" label-width="70px">
                <el-date-picker type="date" placeholder="选择日期" v-model="insureform.end_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="reset_dialogInsureForm('insureform')">取 消</el-button>
          <el-button type="primary" @click="insureSubmitForm('insureform')">确 定</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'     //日期时间转换
import collapse from "../../assets/collapse";
import orderTable from "@/view/order/orderTable.vue";
import eTable from "../common/eTable.vue";
import imgCompressUtil from "../../utils/imgCompressUtil";//压缩图片的js
import axios from '@/axios/axios';

export default {
  // name: "orderListAdd",
  components: {
    collapse,      //展开收缩
    orderTable,
    eTable
  },
  props: {},
  data() {
    return {
      dialogVisible: false,

      fileList: [],

      fileListOne: [],

      fileListTwo: [],
      fileListThree: [],
      fileListFour: [],
      fileListFive: [],
      fileListSix: [],

      // 搜索
      // 基础信息
      baseForm:{
        sn: '',
        operator_id: '',  //工号
        team_name: '',   // 所属团队
        employ_id: '',   // 出单人ID
        chat_date: new Date(),
        status: 0,
      },
      busTableData: [],

      // 身份证信息
      IDCardName:'',
      IDCardAddress: '',
      IDCardBirthday: '',
      IDCardCardno: '',
      IDCardExpiry_date: '',
      IDCardIssue_date: '',
      IDCardIssue_organization: '',
      IDCardNation: '',
      IDCardSex: '',
      IDCardId: '',

      titleCar: '主车信息',
      // 主车信息
      addForm: {
        allPerson: '',   // 所有人
        address: '',  // 住址
        plate_number: '',   // 号牌号码
        use_character: '', // 使用性质
        engine_number: '',  // 发动机号码
        unit: '',   // 发证单位
        issue_date: '',   // 发证日期
        model: '',   // 品牌型号
        register_date: '',   // 注册日期
        vehicleType: '',   // 车辆类型
        vin: '',   // 车辆识别号     
        seating_capacity: '', // 核定载人数
        file_no: '',    // 档案编号
        out_to_out: '' ,  // 外廓尺寸
        total_mass: '',  // 总质量
        record: '', //  检验记录
        fuel_type: '', //  燃油类型
        traction_mass: '',  // 准牵引总质量
        remark: '', // 备注
        core_no: '',  // 证芯编号
        approved_load: '',  // 核定载质量
        curb_weight: '',   // 整备质量
        car_id: '',        // 车辆的id
        trailer_id: '',    // 挂车的id

        operator_name: '',

        contactName: '',
        operator_name: '',
        plate_number: '',
        chat_date: new Date(),

      },
      // 营业执照
      businessForm:{
        shop_id: '',            // 运输公司Id
        certificate_no: '',   // 证件编号
        address: '',          // 地址
        name: '',
        corporation: '',      // 法人
        type: '',             // 类型
        business_scope: '',   // 经营范围
        credit_code: '',     // 社会信用代码
        incorporation_date: '', // 成立日期
        issue_date: '',         // 核准日期
        registered_capital: '', // 注册资本
        taxes_no: '',           // 税号
        composition: '',        // 组成形式
        lifespan: '',           // 有效期
      },
     
      IDCardFront:{},
      IDCardBack:{},
  
      title: '',
      form: {
        role_name: '',
        position: '',
        role_id: '',
        status: '',
      },   
      add_time: '',
      // 新增保险订单
      listData: [],

      // 所属团队 -- 员工（出单人）选择 --
      employData: [],

      // 产品选择添加-------------
      tableData: [],
      checkedDetail: [],
      showEdit: [], // 控制显示及隐藏

      isTableSearchForm: {
        productName: '',
        corpName: ''
      },
      
      productMdForm: {
        corp_id: '',  // 保险公司ID
        product_id: '',  // 保单产品ID
        product_md_id: '',  // 产品方案ID
        corp_channel_id: '', // 企业销售渠道ID
        proposal_form: '',
        policy_no: '',  // 投保单号
        sell_price: '', // 销售价格 
        profit: '',    // 毛利润
        commission: '',// 绩效
        price: '',
        sell_price: '', // 保费
        effective_date: new Date(), // 生效日期  转换
        effectiveDateAdd: '',
        pay_sn: '',
        type: 1, // 收款类型
        member_id: '', // 业务渠道
        member_name: '', // 业务渠道
      },

      page:1,// 当前页码
      limit:10,// 每页大小
      total:0,//总条目数
      //险种方案的验证
      productMdRules: {
        // salePrice: [
        //   { required: true, message: "请输入销售价格", trigger: "blur" },
        // ],
        effective_date: [
          { required: true, message: "请先选择生效日期", trigger: "blur" },
        ],
        // member_name: [
        //   { required: true, message: "请选择业务渠道", trigger: "blur" },
        // ]
      },
      isTableData: [],

      payOrderTableData: [],
      // 表头 ---支付凭证
      payOrderTable: [
        {
          label: "对公/净费",
          field: "credit_code"
        },
        {
          label: "佣金",
          field: ""
        },
        {
          label: "账号",
          field: "address"
        },
        {
          label: "账号名称",
          field: "name"
        },
        {
          label: "凭证流水号",
          field: "add_time"
        },
        {
          label: "凭证金额",
          field: ""
        },
        {
          label: "添加时间",
          field: ""
        }
      ],
      // searchRules: [],
      pageNum: 1,
      pageSize: 15,

      productMd: '',

      editIndex:0,

      teamRadio: '',  // 员工选择
      ProductRadio: '',
      radio: '',

      dialogUpload: false,
      // titleUpload: '支付凭证',
      fileUploadList:[],
      dialogImageUrl: '',
      neiDialog: false,
      formUpload: {
        images: '',
        name: '',
        corpName: '',
        companyName: '',
        remark: '',
      },
      payInfoform: {
        // images: '',
        is_company: '',
        payee_account_number: '',
        account_number: '',
        payee_account: '',
        account: '',
        pay_date: '',
        pay_sn: '',
        pay_money: '',
        commission: '',
        remark: '',
        file_url: '',
        pay_id: '',
      },

      // IsCardLength: false, // 判断是否展示营业执照还是身份证
      // IsShopLength: false,
      
      isSubmitBtn: false,  // 判断保存按钮是否开启
      bankFormRemark: [],

      // 上传回显图片
      carFile: '',
      carUrl: 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg',
      
      shopFile: '',
      shopUrl: 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg',
      
      cardFile: '',
      cardUrl: 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg',

      getPay_sn: '',
      bankReceiptImages: '',
      bankForm:{
        is_company: '',
        commission: '',
        account: '',
        account_number: '',
        payee_account: '',
        payee_account_number: '',
        pay_money: '',
        pay_date: '',
        remark: '',
        // account_bank_name: '',
        // bank_date: '',
        // bank_desc: ''
      },
      shopBindData: [],  // 维护人员
      isCorpId: true,
      rules:{
        // is_company: [{ required: true, message: '请选择是否对公', trigger: 'change' }],
        // pay_money: [{ required: true, message: '请输入凭证金额', trigger: 'blur' }], 
      },
      // ========——+++++上传商业险保险----------++++
      policyDialog: false,
      policyUrl: 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg',
      filePolicyList: [],
      policyform: {
        id: '',
        commercial_url: '',
        start_time: new Date(),
        end_time: new Date()
      },
      policyrules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          }
        ],
      },
      policyDriving: '',

      // ========——+++++上传投保声明（盖章资料）----------++++
      insureDialog: false,
      insureUrl: 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg',
      fileinsureList: [],
      insureform: {
        id: '',
        commercial_url: '',
        start_time: new Date(),
        end_time: new Date()
      },
      insurerules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          }
        ],
      },
      insureDriving: '',
    };
  },
  created() {
    this.employList() // 出单人选择
    this.baseForm.operator_id = window.sessionStorage.getItem('userName')
    this.baseForm.team_name = window.sessionStorage.getItem('userName')
    this.insuranceProduct()
    this.GetSn()
    this.GetPaySN()
  },
  computed: {
   
  },
  mounted() {},
    filters: {
    /**
     * @param {
     *     
     * }
     */
    statusFilter(status) {
      if (status == 1) {
        return "启用";
      } else if (status == 2) {
        return "禁用";
      }
    },
    sexFilter(sex) {
      if (sex == 0) {
        return "女";
      } else if (sex == 1) {
        return "男";
      }
    },
    // 时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
    // 绩效过滤小数
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2)
      return realVal
    }

  },
  methods: {
    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())

      var h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      var mi = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      var s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
    
      return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s
    },
    // 获取单一订单添加的SN
    GetSn() {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }     
        this.$axios.insuranceOrderInfoGetSn(param).then(res => {
            if(res.code == 200){
              this.baseForm.sn = res.data.sn
            }else{
              this.$message.error(res.msg);
            }
        }).catch(function (error) {
          //console.log(error);
        })
      },

    // 图片行驶证识别==================================
    // 点击上传方法
			handleChangeOne(file, fileLists) {
        this.carFile = file.raw
				this.imgCompressOne(file.raw);
			},
			//图片压缩方法
			async imgCompressOne(file) {
				await imgCompressUtil.compressImg(file).then((res) => {
					this.ocrVehicleBaiduOne(res); //调用获取access_token方法并将压缩好的图片base64格式传递过去
				});
			},
       //获取识别行驶证
      ocrVehicleBaiduOne(data) {
        const param = {
          image: data,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }     
        this.$axios.ocrVehicle(param).then(res => {
          if(res.code == 200){
            this.addForm = res.data.car_info      
            this.carUrl = res.data.car_info.file_url.local_file_path   // 行驶证识别图片显示
            if(res.data.car_info.commercial_url == null){
              this.policyUrl = 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg'
            }else{
              this.policyUrl = res.data.car_info.commercial_url   // 商业险保险URL
            }
            if(res.data.shop_info.insure_url == null){
              this.insureUrl = 'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/zanwu.jpg'
            }else{
              this.insureUrl = res.data.shop_info.insure_url   // 投保声明（盖章资料）
            }
      
            if(res.data.car_info.is_main == 0){ 
              this.titleCar = '挂车信息'
              this.addForm.trailer_id = res.data.car_info.trailer_id  
              //console.log(res.data,999);
            }else{
              this.addForm.car_id = res.data.car_info.car_id      
            }
            this.$message.success('上传成功')
            // 判断当前的营业执照是否存在
            if(res.data.shop_info.length != 0){
              this.businessForm = res.data.shop_info
              this.businessForm.shop_id = res.data.shop_info.id
              // this.shopUrl = res.data.shop_info.file_url.local_file_path
              //console.log(this.businessForm.shop_id,555);
            }
            // 获取行驶证图片路径
            let carFd = new FormData()
            carFd.append('file', this.carFile) 
            carFd.append('file_type', 1) 
            carFd.append('file_value', this.addForm.vin) 
            carFd.append('company_id', sessionStorage.getItem('company_id')) 
            carFd.append('access_token', sessionStorage.getItem('token')) 
            this.$axios.ossUploadFile(carFd).then(res => {
              if(res.code == 200){
                this.carUrl = res.data.src
                //console.log(res.data.src,555);
              }
            })       
          }   
      
        }).catch(function (error) {
          //console.log(error);
        })
      },

      // ========营业执照识别==================================
      // 点击上传方法
			handleChangeThree(file, fileLists) {
        this.shopFile = file.raw
				this.imgCompressThree(file.raw);
			},
			//图片压缩方法
			async imgCompressThree(file) {
				await imgCompressUtil.compressImg(file).then((res) => {
					this.ocrVehicleBaiduThree(res); //调用获取access_token方法并将压缩好的图片base64格式传递过去
				});
			},
      ocrVehicleBaiduThree(data) {
        const param = {
          image: data,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }     
        this.$axios.ocrShop(param).then(res => {
          this.businessForm = res
          this.businessForm.shop_id = res.shop_id

          if((this.addForm.allPerson.length)>4){
              this.$message.success('请继续选择添加险种')
            }
            // 获取营业执照图片路径
            let shopFd = new FormData()
            shopFd.append('file', this.shopFile)
            shopFd.append('file_type', 2) 
            shopFd.append('file_value', this.businessForm.shop_id) 
            shopFd.append('company_id', sessionStorage.getItem('company_id')) 
            shopFd.append('access_token', sessionStorage.getItem('token')) 
            this.$axios.ossUploadFile(shopFd).then(res => {
              if(res.code == 200){

                this.shopUrl = res.data.src
              }
            })

        }).catch(function (error) {
          //console.log(error);
        })
      },
    // ========身份证识别==================================
      // 点击上传方法
			handleChangeFour(file, fileLists) {
         if(this.addForm.allPerson == ''){
          this.$message.error('请先上传行驶证识别')
        }else{
          this.cardFile = file.raw
          this.imgCompressFour(file.raw);
        }
			},
			//图片压缩方法
			async imgCompressFour(file) {
				await imgCompressUtil.compressImg(file).then((res) => {
					this.ocrVehicleBaiduFour(res); //调用获取access_token方法并将压缩好的图片base64格式传递过去
				});
			},
      ocrVehicleBaiduFour(data) {
        const param = {
          image: data,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }     
        this.$axios.ocrIDCard(param).then(res => {
          
          this.IDCardName = res.name
          this.IDCardAddress = res.address
          this.IDCardCardno = res.cardno
          this.IDCardBirthday = res.birthday
          this.IDCardExpiry_date = res.expiry_date
          this.IDCardIssue_organization = res.issue_organization
          this.IDCardIssue_date = res.issue_date
          this.IDCardNation = res.nation
          this.IDCardSex = res.sex
          this.IDCardId = res.shop_id

          this.businessForm.shop_id = res.shop_id

          // 获取身份证图片路径
          let cardFd = new FormData()
          cardFd.append('file', this.cardFile)
          cardFd.append('file_type', 3) 
          cardFd.append('file_value', this.IDCardId) 
          cardFd.append('company_id', sessionStorage.getItem('company_id')) 
          cardFd.append('access_token', sessionStorage.getItem('token')) 
          this.$axios.ossUploadFile(cardFd).then(res => {
            if(res.code == 200){
              this.cardUrl = res.data.src
            }
          }).catch(function (error) {
            //console.log(error);
          })
        }).catch(function (error) {
          //console.log(error);
        })
      },
        // 身份反面识别 +++++++++++++++++
      // 点击上传方法
      handleChangeFive(file, fileLists) {
        if(this.addForm.allPerson == ''){
          this.$message.error('请先上传行驶证识别')
        }else{
          this.imgCompressFive(file.raw);
        }
      },
      	//图片压缩方法
			async imgCompressFive(file) {
				await imgCompressUtil.compressImg(file).then((res) => {
					this.ocrVehicleBaiduFive(res); //调用获取access_token方法并将压缩好的图片base64格式传递过去
				});
			},
      ocrVehicleBaiduFive(data) {
        const param = {
          image: data,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }     
        this.$axios.ocrIDCard(param).then(res => {
          this.IDCardExpiry_date = res.expiry_date
          this.IDCardIssue_organization = res.issue_organization
          this.IDCardIssue_date = res.issue_date
          //console.log(res.issue_organization,'反面分段');
        }).catch(function (error) {
          //console.log(error);
        })
      },
    // 所属团队  ---- 员工 ----
        // 获取当前选择的产品分类的值
    changeEmployValue(e){
      //console.log(e);
      this.baseForm.employ_id = e
    },
    // 出单人选择
    employList() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.employeeNoPage(param).then(res=>{
        if(res.code == 200){
          // 获取检索部门出单人员
          let arrData = []
          res.data.forEach(value => {
            if(value.department_name == '渠道部'){
              arrData.push(value)
            }
          });
          this.employData = arrData
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
     // ---------- 业务渠道 -----------------
    //  selectBlur(e) {
    //   // 意见类型
    //   if (e.target.value !== '') {
    //     this.value = e.target.value;
    //     this.$forceUpdate()   // 强制更新
    //   }
    //   },
    //   selectClear() {
    //   this.value = ''
    //   this.$forceUpdate()
    //   },
    //   selectChange(val) {
    //     this.value = val
    //     this.baseForm.member_id = val
    //     //console.log(val,999);
    //     this.$forceUpdate()
    //   },

     // ---------- 业务渠道 下拉搜索-----------------
    //  busChannel() {
    //   const param = {
    //     company_id:sessionStorage.getItem('company_id'),
    //     access_token:sessionStorage.getItem('token'),
    //   }
    //   this.$axios.crmMembeListNoPage(param).then(res=>{
    //     if(res.code == 200){
    //       this.busTableData = res.data
    //     }
    //   }).catch(error=>{
    //     //console.log(error);
    //   })
    // },
    // handelDetail(index,row) {
    //   this.$router.push({
    //       path: '/carQueryDetails',
    //       query: {
    //           id: index.data.row.id
    //       }
    //   });
    // },

    // ---------===== 产品险种方案  ===============
    // // 险种方案信息

    insuranceProduct() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.insuranceProductList(param).then(res=>{
          if(res.code == 200){
            this.isTableData = res.data.data
          }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 险种方案的选择弹窗搜索
    isSearchSubmit() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        queryParams: this.isTableSearchForm.productName,
      }
      //console.log(78,param);
      this.$refs.isSearchForRef.validate((valid) => {
        if (valid) {
          this.$axios.insuranceProductList(param).then(res=>{
            if(res.code == 200){
              this.isTableData = res.data.data
            }
          }).catch(error =>{
              //console.log(error);
          })
        }
      })
    },
    // 险种方案
    handInsuranceScheme(e) {
      //console.log(e);
      this.editIndex= e.data.row;

    },
    // 产品方案赋值
    handelProductMd(e) {
      //console.log(111,e.data.row);
      
      this.productMd = e.data.row
      this.tableData[this.editIndex].productMd = e.data.row.title
      this.editIndex= e.data.row;
    },
    // 单选选择切换数据
    getCurrentRow(row){    
      //console.log(row,222);
      this.dialogUpload = true;
      // 判断当前是否是国人的订单
      if( row.corp_id != 33){
        this.isCorpId = true
        this.productMdForm.corp_id = row.corp_id;
        this.productMdForm.product_id = row.product_id;
        this.productMdForm.corp_channel_id = row.corp_channel_id;
        this.productMdForm.product_md_id = row.id
        this.productMdForm.policy_no = row.policy_no;
        this.productMdForm.price = row.price;
        this.productMdForm.sell_price = row.sell_price;
      }else{
        this.isCorpId = false
        this.productMdForm.product_md_id = row.id
        this.productMdForm.sell_price = row.sell_price;
        this.productMdForm.price = row.price;
      }
      // this.productMdForm.real_price= row.real_price;

      // this.productMdForm.salePrice = '';
      // this.productMdForm.profit = '';
      this.productMdForm.commission = (parseFloat(parseFloat(row.sell_price) - parseInt(this.productMdForm.price))*0.184).toFixed(2); //绩效 基础的
      this.productMdForm.profit = parseFloat(row.sell_price) - parseInt(this.productMdForm.price) //毛利润
      this.isSubmitBtn = true  // 判断保存按钮是否开启
    },
    // 险种方案选择确认数据
    // productMdFormSubmit() {     
    //   // 产品的验证规则
    //   if(this.productMdForm.corp_id != ''){
    //     this.$refs.productForRef.validate((valid) => {
    //       if (valid) {
    //         this.productMdForm.effectiveDateAdd = this.productMdForm.effective_date   // 生效日期
    //         this.productMdForm.effective_date = this.getTime(this.productMdForm.effective_date)
    //         //console.log(this.productMdForm.effective_date,3445);
    //       }
    //     })
    //   }else{
    //     this.$message.error('请先选择险种方案')
    //   }
    // },
    // 表格的新增
    rowClassName({ row, rowIndex }) {
      row.xh = rowIndex + 1
    },
    // 单选框选中数据
    handleDetailSelectionChange(selection) {
      this.checkedDetail = selection
    },

    // 删除
    handleDeleteBtn() {
      if (this.checkedDetail.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {
          confirmButtonText: '确定'
        })
      } else {
        this.$confirm('请是否确认删除该属性?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          callback: (action) => {
            if (action === 'confirm') {
              const val = this.checkedDetail
              val.forEach((val, index) => {
                this.tableData.forEach((v, i) => {
                  if (val.xh === v.xh) {
                    this.tableData.splice(i, 1)
                  }
                })
              })
              this.$message({
                message: '删除成功，记得保存修改喔！',
                type: 'success'
              })
              this.$refs.tb.clearSelection()
              return
            } else {
              this.$message({
                message: '已取消删除操作',
                type: 'warning'
              })
              return
            }
          }
        })
      }
    },
    // 点击修改
    showUpdate(index, row) {
      //console.log('index')
      this.showEdit[index] = true
      this.$set(this.showEdit, index, true) // 这里要用$set方法，否则页面状态不更新
    },
    // 取消修改
    cancelUpdate(index) {
      this.$confirm('取消修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$set(this.showEdit, index, false)
        })
        .catch(() => {})
    },
    // 提交修改
    submit(index, row) {
      // 发送请求，隐藏输入框
      this.$message({
        type: 'success',
        message: '已缓存，记得点击保存提交修改喔！',
        duration: 888,
        onClose: () => {
          this.$set(this.showEdit, index, false) // vue添加属性的方法
        }
      })
    },
    // 获取页面的 getPay_sn
    GetPaySN() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }     
      this.$axios.getPaySN(param).then(res => {
        if(res.code == 200){
          this.getPay_sn = res.data.pay_sn
        }
      }).catch(function (error) {
        //console.log(error);
      })
    },
    // ========财务票据-识别银行回单信息==================================
    // 支付凭证封面上传
    //上传图片的方法
    UploadImage(file,filelist) {
      //console.log(file);
      this.bankReceiptImages = file.raw 
      this.UploadImageimgCompress(file.raw)

      let payFd = new FormData()
      payFd.append('file', file.raw) 
      payFd.append('file_type', 5) 
      payFd.append('file_value', this.getPay_sn) 
      payFd.append('company_id', sessionStorage.getItem('company_id')) 
      payFd.append('access_token', sessionStorage.getItem('token')) 
      //console.log(payFd,333);
      this.$axios.ossUploadFile(payFd).then(res=>{
        //console.log(res);
        if(res.code == 200){
          this.dialogImageUrl = res.data.src
          // 财务票据，识别通用
          //console.log(file,9938934);
        }
      })
      .catch(error => console.log(error))
    },
    //图片压缩方法
    async UploadImageimgCompress(file) {
      await imgCompressUtil.compressImg(file).then((res) => {
        this.ocrVehiceBank(res); //调用获取access_token方法并将压缩好的图片base64格式传递过去
      });
    },

    ocrVehiceBank(data) {
      const param = {
        image: data,
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }    
      this.$axios.ocrBankReceiptNew(param).then(res => {
        if(res.code == 200){
          this.bankForm = res.data.res
          this.$message.success(res.msg+'点击此图片可查看明细')
        }
        //console.log(res,33333333);
      }).catch(function (error) {
        //console.log(error);
      })
    },
    // 判断是否是对公
    IsCompanyChange(val) {
      //console.log(val);
      if(this.bankForm.is_company == 1){
        this.bankForm.commission = this.productMdForm.commission
      }else{
        this.bankForm.commission = ''
      }
    },
    //预览图片功能
    handlePictureCardPreview() {
      //console.log(11);
      //console.log(this.dialogImageUrl,888);
      this.neiDialog = true
    },
    // 支付凭证保存
    payInfoSubmit() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        pay_sn: this.getPay_sn,
        
        is_company: this.bankForm.is_company,
        commission: this.bankForm.commission,
        account: this.bankForm.account,
        account_number: this.bankForm.account_number,

        payee_account: this.bankForm.payee_account,
        payee_account_number: this.bankForm.payee_account_number,
        pay_money: this.bankForm.pay_money,
        pay_date:this.bankForm.pay_date,

        remark: this.bankForm.remark,

        // file_url: this.payInfoform.image,
      }
      //console.log(78,param);
      this.$refs.isSearchForRef.validate((valid) => {
        if (valid) {
          this.$axios.payProductSave(param).then(res=>{
            if(res.code == 200){
              //console.log(res,9999);
              this.payInfoform.pay_id = res.data.pay_id
              // this.payInfoform.pay_sn = res.data.pay_sn
              this.productMdForm.pay_sn = res.data.pay_sn
              this.dialogUpload = false
            }
          }).catch(error =>{
              //console.log(error);
          })
        }
      })
    },
    resetPayInfoSubmit() {
      this.dialogUpload = false
      // this.$refs[formName].resetFields();
    },

    // ========商业险保险URL==================================
    // 点击上传方法
    handleChangeShop() {
      //console.log(1111);
      this.policyDialog = true
    },
    // ++++++++====上传文件 商业险保险 =====+++++++++
    reset_dialogPolicyForm(formName) {
      this.policyDialog = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    policyUpload(file, fileLists) {
        this.policyDriving = file.raw
        let policyFd = new FormData()
        policyFd.append('file', this.policyDriving)
        policyFd.append('file_type', 8) 
        policyFd.append('file_value', this.addForm.car_id) 
        policyFd.append('company_id', sessionStorage.getItem('company_id')) 
        policyFd.append('access_token', sessionStorage.getItem('token')) 
        //console.log(policyFd,33);
        this.$axios.ossUploadFile(policyFd).then(res =>{
            if(res.code == 200){
              this.policyform.commercial_url = res.data.src
            }else{
                this.$message.error(res.msg);
            }
        })
		},
    policySubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            const param = {
              id: this.addForm.car_id,
              commercial_url: this.policyform.commercial_url,
              start_time: Date.parse(this.policyform.start_time),
              end_time: Date.parse(this.policyform.end_time),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
            }     
            //console.log(param,988);
            this.$axios.crmCommercialEdit(param).then(res =>{
                //console.log(res,7777);
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.policyDialog = false
                }else{
                    this.$message.error(res.msg);
                }
            })
          }  
        }) 
    },
    // ========上传投保声明（盖章资料）==================================
    // 点击上传方法
    handleChangeInsure() {
      //console.log(1111);
      this.insureDialog = true
    },
    // ++++++++====上传投保声明（盖章资料） =====+++++++++
    reset_dialogInsureForm(formName) {
      this.insureDialog = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    insureUpload(file, fileLists) {
        this.insureDriving = file.raw
        let insureFd = new FormData()
        insureFd.append('file', this.insureDriving)
        insureFd.append('file_type', 9) 
        insureFd.append('file_value', this.businessForm.shop_id) 
        insureFd.append('company_id', sessionStorage.getItem('company_id')) 
        insureFd.append('access_token', sessionStorage.getItem('token')) 
        //console.log(insureFd,33);
        this.$axios.ossUploadFile(insureFd).then(res =>{
            if(res.code == 200){
              this.insureform.insureUrl = res.data.src
            }else{
                this.$message.error(res.msg);
            }
        })
		},
    insureSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            const param = {
              id: this.businessForm.shop_id,
              insure_url: this.insureform.insureUrl,
              start_time: Date.parse(this.insureform.start_time),
              end_time: Date.parse(this.insureform.end_time),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
            }     
            //console.log(param,988);
            this.$axios.shopInsureEdit(param).then(res =>{
                //console.log(res,7777);
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.insureDialog = false
                }else{
                    this.$message.error(res.msg);
                }
            })
          }  
        }) 
    },

    reset_dialogForm(formName) {
      // this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
  
    // 当前单一订单保存
    submitAllForm() {
      //console.log(this.businessForm.shop_id,88888);
      const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          sn: this.baseForm.sn,
          team_id: this.baseForm.employ_id,
          member_id: this.baseForm.member_id,

          shop_id: this.businessForm.shop_id,
          engine_number: this.addForm.engine_number,
          unit: this.addForm.unit,
          issue_date: this.addForm.issue_date,
          plate_number: this.addForm.plate_number,
          model: this.addForm.model,
          register_date: this.addForm.register_date,
          vehicleType: this.addForm.vehicleType,
          vin: this.addForm.vin,
          curb_weight: this.addForm.curb_weight,
          seating_capacity: this.addForm.seating_capacity,
          file_no: this.addForm.file_no,
          out_to_out: this.addForm.out_to_out,
          total_mass: this.addForm.total_mass,
          record: this.addForm.record,
          fuel_type: this.addForm.fuel_type,
          traction_mass: this.addForm.traction_mass,
          remark: this.addForm.remark,
          core_no: this.addForm.core_no,
          approved_load: this.addForm.approved_load,
          curb_weight: this.addForm.curb_weight,

          name: this.IDCardName,
          address: this.IDCardAddress,
          cardno: this.IDCardCardno,
          birthday: this.IDCardBirthday,
          expiry_date: this.IDCardExpiry_date,
          issue_organization: this.IDCardIssue_organization,
          issue_date: this.IDCardIssue_date,
          nation: this.IDCardNation,
          sex: this.IDCardSex,
          // 产品选择
          goods_list:{
            pay_id: this.payInfoform.pay_id,  //支付凭证的pay_id
            corp_id: this.productMdForm.corp_id,
            product_md_id: this.productMdForm.product_md_id,
            product_id: this.productMdForm.product_id,
            corp_channel_id: this.productMdForm.corp_channel_id,
            policy_no: this.productMdForm.policy_no,
            proposal_form: this.productMdForm.proposal_form,

            sell_price: this.productMdForm.sell_price,
            price: this.productMdForm.price,
            rate: this.productMdForm.rate,
            effective_date: this.productMdForm.effective_date,

            // real_price: this.productMdForm.real_price,
            profit: this.productMdForm.profit,
            commission: this.productMdForm.commission,
            pay_id: this.payInfoform.pay_id,  // 支付凭证的id
            // remark: this.payInfoform.remark,
            type: this.productMdForm.type,
          },
          car_list:{
            car_id: this.addForm.car_id,   // 车辆的id
            trailer_id: this.addForm.car_id,  // 挂车的id
            owner_id: this.businessForm.shop_id,   // 投保人
          }
        }
        //console.log(param,666666666666);
        this.$axios.shopSaveOrderNew(param).then(res=>{
          if(res.code == 200){
            this.$message.success('添加成功');
            this.$router.push("/orderList");
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error =>{
            //console.log(error);
        })
        
    },


  },
};
</script>
<style lang="less" scoped>
  .table_name{
    font-weight: bold;
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  
.el-collapse{
  border: none;
}

.customer_isActive{
  margin-left: 20px;
  cursor: pointer;
}
.customer_box{
  margin-bottom: 35px;
}
// 顶部的六个图片
.upload_group{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .upload_list{
    width: 120px;
    // height: 50px;
    margin-right: 1rem;
  }
  /deep/.el-upload-dragger .el-upload__text{
    font-size: 10px;
    color: #409EFF;
  }
  /deep/.el-icon-upload:before{
    width: 40px!important;
    height: 40px!important;
  }
  .upload_list:last-child{
    margin-right: 0;
  }
  /deep/.el-upload-dragger{
    width: 100%;
    height:auto;
    padding: 20px 0;
    border: 1px solid #999;
  }
  /deep/.el-upload{
    width: 100%;
  }
 /deep/.el-upload-dragger .el-icon-upload{
  margin:10px 0;
 }
}


.zhu_box{
  // border: 1px solid #f00;
  height: 390px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e8e8e8;
}
// /deep/.base_box .el-input{
//   width: 70%;
//   border: 1px solid #f00;l
// }
/deep/.el-input--suffix .el-input__inner{
  padding-right: 15px;
}
/deep/.upload-demo{
  margin: 0;
}
.pay_upload{
  width: 140px;
  height: 80px;
  /deep/.el-upload-dragger{
    width: 148px;
    height: 78px;
  }
  /deep/.el-icon-plus{
    color: #d9d9d9;
    font-size: 30px;
    padding-top: 20px;
  }
}
.el_upload_border{
    border: 1px solid #999;
    color: #409EFF;
    padding: 20px 0;
    text-align: center;
    font-size: 10px;
    border-radius: 5px;
}

/deep/.el-table .el-table__cell{
    padding: 2px!important;
  }

</style>



// WEBPACK FOOTER //
// src/view/shipCompany/shopOrderShopAdd.vue